<template>
    <div class="ordersubmit">
        <header-component></header-component>
        <div class="container-fluid g-my-100">
            <div class="row">
                <div class="col-lg-8 offset-lg-2 center">
                    <p class="contract-header">Congratulations</p>
                    <p>Your frame collection order has successfully been placed!</p>
                    <p>Your collection will arrive in 2 to 4 weeks.</p>
                    <p>Your will receipt will be emailed to you.</p>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <button @click="Route('Home')" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10">Return Home</button>
                            <button @click="Route('Order')" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10">Place New Order</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <frame-shipping-billing @close="ToggleBilling()" v-if="isBillingShown"></frame-shipping-billing>
        <footer-component></footer-component>
    </div>
</template>
<script>
    import FrameShippingBilling from "@/components/portal/frameResources/frameComponents/FrameShippingBilling";
    import HeaderComponent from "@/components/shared/HeaderComponent";
    import FooterComponent from "@/components/shared/FooterComponent";
    export default {
        components: {HeaderComponent, FooterComponent, FrameShippingBilling},
        data(){
            return{
                isBillingShown:true
            }
        },
        methods: {
            Route(value){
                this.$router.push({name: value});
            }, 
            ToggleBilling(){
                this.isBillingShown = !this.isBillingShown;
            }           
        },
        created(){
            localStorage.setItem('is-active','frame');
        }
    }
</script>



// WEBPACK FOOTER //
// FrameOrderSuccess.vue?bb68451c